import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, Subject } from 'rxjs';
import {
  BaseAuthenticatedService,
  httpQueryParams,
  PaginatedResponse,
  RecursiveInterface,
} from './base-authenticated.service';
import { MessageInterface } from '@app/interface/messages';

@Injectable({
  providedIn: 'root',
})
export class MessageApiService extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient // private cookieService: CookieService
  ) {
    super(auth, httpClient);
  }

  // using getRecursivePage
  public getAllMessages<T = MessageInterface>(
    organization_id: number | null,
    params: httpQueryParams = {}
  ): Subject<RecursiveInterface<T>> {
    const path = `api/${organization_id}/message/`;
    return this.getRecursivePage<T>(path, params);
  }

  public createMessage(
    organization_id: number | null,
    messageData: Partial<MessageInterface>
  ): Observable<MessageInterface> {
    if (!messageData.organization_id) {
      messageData.organization_id = 1; // Default to company with ID 1
    } else {
      organization_id = messageData.organization_id;
    }
    const path = `api/${organization_id}/message/`;

    return this.post<MessageInterface>(path, {}, messageData);
  }

  public updateMessage(
    organization_id: number | null,
    id: number,
    data: Partial<MessageInterface>
  ): Observable<MessageInterface> {
    console.log(data);
    return this.partialUpdate<MessageInterface>(
      `api/${organization_id}/message/${id}/`,
      {}, //{ withCredentials: true },
      data
    );
  }
}
